import React, { ComponentType } from 'react';
import { Redirect, RouteComponentProps } from '@reach/router';

type Props = { component: ComponentType } & RouteComponentProps;

export const Route: ComponentType<Props> = ({
  component: Component,
  ...rest
}) => <Component {...rest} />;

export const PrivateRoute: ComponentType<Props> = ({
  component: Component,
  path,
  ...rest
}: any) => {
  return localStorage.getItem('token') ? (
    <Component {...rest} />
  ) : (
    <Redirect to="/login" noThrow state={{ from: path }} />
  );
};

export const AuthorizationRoute: ComponentType<Props> = ({
  component: Component,
  path,
  ...rest
}: any) => {
  return localStorage.getItem('token') ? (
    <Redirect to="/" noThrow state={{ from: path }} />
  ) : (
    <Component {...rest} />
  );
};
